import { render, staticRenderFns } from "./putaway.vue?vue&type=template&id=6f19a4b4&scoped=true"
import script from "./putaway.vue?vue&type=script&lang=js"
export * from "./putaway.vue?vue&type=script&lang=js"
import style0 from "./putaway.vue?vue&type=style&index=0&id=6f19a4b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19a4b4",
  null
  
)

export default component.exports